module.exports = __webpack_public_path__ + "src/assets/games/42/58.jpg";